import { useState, useEffect } from 'react';
import axios from 'axios';


const shipmentTrackingUrl = (id) => `${process.env.REACT_APP_API_URL}track/${id}`;

function originIsSafe(origin) {
  return process.env.NODE_ENV === 'test' || origin.match(/localhost:[0-9]+/) || origin.match(/\.shippingeasy\.com$/) ||  origin.match(/\.shipstation\.com$/);
}

export default function useShipmentTrackingData({ id, isPreview, mockPreviewData }) {
  const [state, setState] = useState({ branding: {}, loaded: false });

  const [previewData, setPreview] = useState(() => ({
    previewListener: window.addEventListener('message', (msg) => {
      if (originIsSafe(msg.origin) && msg.data.source === 'branded-tracking-preview') {
        setPreview({ branding: msg.data.branding, preview: msg.data.preview });
      }
    }),
  }));

  useEffect(() => {
    if( isPreview ) {
      const data = mockPreviewData;
      const settings = (data.branding && data.branding.settings) || {};
      data.branding = { ...data.branding, ...settings };
      data.loaded = true;
      setState(data);
    } else {
      axios.get(shipmentTrackingUrl(id)).then(
        (response) => {
          const { data } = response;
          const settings = (data.branding && data.branding.settings) || {};
          data.branding = { ...data.branding, ...settings };
          data.loaded = true;
          setState(data);
        },
      );
    }
  }, [id, mockPreviewData, isPreview]);

  // NB - if we ever need to return a `setState` here this whole process will need to be rethought
  return [{
    ...state,
    branding: {
      ...state.branding,
      ...previewData.branding,
    },
    preview: {
      isPreview,
      ...(previewData.preview || {})
    }
  }, setState];
}
